<script lang="ts">
  import FileNodeComponent from './FileNode.svelte'
  
  interface Props {
    node: any
    selectedFiles: Set<string>
    focusedNodeId: string | null
    draggedFiles: Set<string>
    editingNodeId: string | null
    editingTitle: string
    editingDuplicateWarning?: string
    isFileOpen: (id: string) => boolean
    onSelectFile: (node: any, event: MouseEvent) => void
    onContextMenu: (node: any, event: MouseEvent) => void
    onDragStart: (node: any, event: DragEvent) => void
    onDragEnd: () => void
    onStartEdit: (node: any) => void
    onFinishEdit: () => void
    onEditKeydown: (event: KeyboardEvent) => void
    onEditTitleChange?: (value: string) => void
  }
  
  let {
    node,
    selectedFiles,
    focusedNodeId,
    draggedFiles,
    editingNodeId,
    editingTitle,
    editingDuplicateWarning = '',
    isFileOpen,
    onSelectFile,
    onContextMenu,
    onDragStart,
    onDragEnd,
    onStartEdit,
    onFinishEdit,
    onEditKeydown,
    onEditTitleChange
  }: Props = $props()
</script>

<!-- Wrapper to isolate root level files from folder files -->
<div class="root-file-wrapper" data-root-file="true">
  <FileNodeComponent
    id={node.id}
    name={node.name}
    document={node.document}
    isReadError={node.isReadError}
    isImage={node.isImage}
    extension={node.extension}
    depth={0}
    isOpen={isFileOpen(node.id)}
    isSelected={selectedFiles.has(node.id)}
    isFocused={focusedNodeId === node.id}
    isDragged={draggedFiles.has(node.id)}
    onSelect={(e) => onSelectFile(node, e)}
    onContextMenu={(e) => onContextMenu(node, e)}
    onDragStart={(e) => onDragStart(node, e)}
    onDragEnd={onDragEnd}
    onStartEdit={() => onStartEdit(node)}
    {editingNodeId}
    {editingTitle}
    {editingDuplicateWarning}
    onFinishEdit={onFinishEdit}
    onEditKeydown={onEditKeydown}
    onEditTitleChange={onEditTitleChange}
  />
</div>

<style>
  .root-file-wrapper {
    /* This wrapper creates a different rendering context */
    display: contents;
  }
</style>